import { exists } from '@/api'

export interface BatchTohanBooksOrderDataCreateConditionListItem {
  traderType: string
  branch: string
  isOutputAlreadyOrder: boolean
  rdoSetNumberType: string
  orderDateFrom: string
  orderDateTo: string
  batchType: string
}

export function BatchTohanBooksOrderDataCreateConditionListItemFromJSON(
  json: any
): BatchTohanBooksOrderDataCreateConditionListItem {
  const resp = JSON.parse(json)

  return {
    traderType: exists(resp, 'trader_type') ? resp.trader_type : '',
    branch: exists(resp, 'branch') ? resp.branch : '',
    isOutputAlreadyOrder: exists(resp, 'is_output_already_order')
      ? resp.is_output_already_order
      : false,
    rdoSetNumberType: exists(resp, 'rdo_set_number_type')
      ? resp.rdo_set_number_type
      : '1',
    orderDateFrom: exists(resp, 'order_date_from') ? resp.order_date_from : '',
    orderDateTo: exists(resp, 'order_date_to') ? resp.order_date_to : '',
    batchType: resp.batch_type
  }
}
